// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.access-parent-row[data-v-53ecf119] {\n  background: hsl(222, 77%, 95%);\n  font-weight: bold;\n}\n.access-parent-row.theme-dark[data-v-53ecf119] {\n  background: hsl(222, 77%, 15%);\n}\n", ""]);
// Exports
module.exports = exports;
